import { getParam } from '../utils/marketingHelper';

const REFERRAL_SOURCE_VALUE = 'friends';
// Values must match ONE_LINK_PARAMS_MAP's keys — getParam resolves the onelink alias through them.
const UTM_CAMPAIGN_PARAM = 'utm_campaign';
const UTM_SOURCE_PARAM = 'utm_source';
const CAPTURED_AT_KEY = 'utm_campaign_captured_at';

// A held referral is a pending signup, not a permanent property of the browser. Matches rips-ui.
const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export class ReferralService {
  private static getReferrerIdFromSearchParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const spReferrerId = getParam(urlParams, UTM_CAMPAIGN_PARAM);
    const spReferralSource = getParam(urlParams, UTM_SOURCE_PARAM);

    if (spReferralSource !== REFERRAL_SOURCE_VALUE || !spReferrerId) {
      return;
    }

    return spReferrerId;
  }

  private static getReferrerIdFromLocalStorage() {
    try {
      const lsReferrerId = localStorage.getItem(UTM_CAMPAIGN_PARAM);
      const lsReferralSource = localStorage.getItem(UTM_SOURCE_PARAM);

      if (lsReferralSource !== REFERRAL_SOURCE_VALUE || !lsReferrerId) {
        return;
      }

      const capturedAt = Number(localStorage.getItem(CAPTURED_AT_KEY));

      // Codes stored before this key existed have no age; stamp them so the TTL starts running.
      if (!capturedAt) {
        localStorage.setItem(CAPTURED_AT_KEY, String(Date.now()));
      } else if (Date.now() - capturedAt > REFERRAL_TTL_MS) {
        this.clear();

        return;
      }

      return lsReferrerId;
    } catch {
      // Blocked storage (private mode) — only a referral still on the url can be honoured.
      return undefined;
    }
  }

  private static persistReferrerId(referrerId: string) {
    try {
      localStorage.setItem(UTM_CAMPAIGN_PARAM, referrerId);
      localStorage.setItem(UTM_SOURCE_PARAM, REFERRAL_SOURCE_VALUE);
      localStorage.setItem(CAPTURED_AT_KEY, String(Date.now()));
    } catch {
      // Blocked storage — the referrer survives only as long as the url params do.
    }
  }

  static getReferrerUniqueId() {
    const spReferrerId = this.getReferrerIdFromSearchParams();

    if (spReferrerId) {
      // Write through: the params are usually gone by signup, and a stale stored id would win.
      this.persistReferrerId(spReferrerId);

      return spReferrerId;
    }

    return this.getReferrerIdFromLocalStorage();
  }

  static updateReferralData() {
    this.getReferrerUniqueId();
  }

  static clear() {
    try {
      localStorage.removeItem(UTM_CAMPAIGN_PARAM);
      localStorage.removeItem(UTM_SOURCE_PARAM);
      localStorage.removeItem(CAPTURED_AT_KEY);
    } catch {
      // Nothing to clean when storage is blocked.
    }
  }
}
